/**
 * Open the Usercentrics second layer from the Floyd footer privacy link.
 * Delegation covers dynamically rendered footers without polling the DOM.
 */
(function () {
    document.addEventListener('click', function (event) {
        var target = event.target;
        var link = target && target.closest
            ? target.closest('.footer__block.footer__block--links a.link-faded[href*="/pages/cookie-settings"]')
            : null;

        if (!link) return;

        event.preventDefault();
        event.stopPropagation();

        try {
            window.UC_UI.showSecondLayer();
        } catch (_) {
            // Keep the privacy URL as a progressive-enhancement fallback when the CMP is unavailable.
            window.location.assign(link.href);
        }
    });
})();
